<template>
    <v-container>
        <div>
            <v-row justify="space-between">
                <v-col cols="12" sm="6" justify="center">
                    <p class="header-title"> {{$t('idea_request.approve_title')}} </p>
                </v-col>

                <v-col cols="12" sm="6" justify="center">
                    <!-- <v-row class="d-flex justify-end">
                        <v-btn color="primary" dark class="mb-2" @click="showCreateRequestDialog">{{ $t('idea_request.add')}}</v-btn>
                    </v-row> -->
                    <div class="d-flex flex-row-reverse">
                        <v-btn color="primary" dark @click="showCreateRequestDialog">{{ $t('idea_request.add')}}</v-btn>
                        <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="email" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
            <template v-slot:top>
                <v-toolbar flat color="white" >
                    <v-row justify="start" class="pt-5">
                        <v-col cols="12" sm="3">
                            <v-autocomplete v-model="selectFilterCategory" :items="filterCategories" v-bind:label="$t('idea_request.category')" item-text="name" outlined :dense="true" return-object></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="2">
                        </v-col>

                        <v-col cols="12" sm="7">
                            <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
                        </v-col>
                    </v-row>
                </v-toolbar>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <v-icon small class="mr-2" @click="showDetail(item)">
                    info
                </v-icon>
                <v-icon  small class="mr-2"  @click="editItem(item)">
                    edit
                </v-icon>
                <v-icon  small @click="deleteItem(item)">
                    delete
                </v-icon>
            </template>

            <template v-slot:[`item.user`]="{ item }">
                <div class="contentAddress">
                    <v-avatar size="30" class="mr-1">
                        <img v-if="item.user.avatar" :src="baseImage + item.user.avatar"/>
                        <img v-else src='@/assets/avatar_default.png'/>
                    </v-avatar>

                    <span class="text-no-wrap"> {{ item.user.fullname }} </span> 
                </div>
            </template>

            <template v-slot:[`item.description`]="{ item }">
                <span class="contentTitle">
                    {{ item.description }}
                </span>
            </template>

            <template v-slot:[`item.publish`]="{ item }">
                <v-btn color="primary" dark @click="approve(item)">
                    {{ $t('idea_request.approve') }}
                </v-btn>
            </template>

            <template v-slot:[`item.category`]="{ item }">
                <div class="contentAddress">
                    <span class="text-no-wrap"> {{ item.category.name }} </span> 
                </div>
            </template>

            <template v-slot:[`item.name`]="{ item }">
                <span class="contentTitle">
                    {{ item.name }}
                </span>
            </template>

            <template v-slot:[`item.files`]="{ item }">
                <span class="contentTitle">
                    {{ item.files ? item.files.length : 0 }}
                </span>
            </template>

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>

        <v-dialog v-model="createRequestDialog" persistent max-width="70%">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        
                        <v-row no-gutters>
                            <v-col>
                                <v-autocomplete v-model="selectedCategory" :items="categories" item-text="name" v-bind:label="$t('idea_request.category')" outlined :dense="true" return-object></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col>
                                <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('idea_request.name')" outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col>
                                <!-- <v-textarea v-model="editedItem.description" v-bind:label="$t('idea_request.description')" outlined required dense>
                                </v-textarea> -->
                                <vue-editor v-model="editedItem.description" :editorOptions="editorOptions" :placeholder="$t('idea_request.description')">
                                </vue-editor>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pt-5">
                            <v-col cols="12">
                                <upload-dialog @uploadFileSuccess="uploadFile"> </upload-dialog>
                                <v-row v-for="file in filesUploaded" :key="file._id">
                                    <v-col cols="12" sm="6">
                                        <a :href="baseAttach + file._id" target="_blank">
                                            {{ file.filename }}
                                        </a>
                                    </v-col>
                                    <v-col cols="12" sm="2">
                                        <v-icon @click='deleteFile(file)'> delete </v-icon>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="closeCreateDialog">{{ $t('common.cancel')}}</v-btn>
                    <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <present-idea-request v-model="dialogInfor" :editedItem="editedItem" @closeDialog="closeDialogInfor" v-if="editedItem"></present-idea-request>
    </v-container>
</template>

<script>
    import i18n from '@/plugins/i18n';
    import UploadDialog from "@/components/UploadDialog";
    import PresentIdeaRequest from "@/components/PresentIdeaRequest";
    import { VueEditor } from "vue2-editor";

    export default {
        data: () => ({
            baseImage: process.env.VUE_APP_BASE_IMAGE,
            baseAttach: process.env.VUE_APP_BASE_ATTACH,
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,

            isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
            userID: localStorage.getItem('user_id'),

            createRequestDialog: false,
            filesUploaded: [], 

            selectedCategory: {},
            categories: [],

            selectFilterCategory: {
                name : "Tất cả",
                _id : "-1"
            },

            dialogInfor: false,
            filterCategories: [],

            search: '',
            dialog: false,
            loading: true,
            headers: [],

            desserts: [],
            fullRequests: [],
            editedIndex: -1,
            editedItem: {
            },
            defaultItem: {
            },
            stringRules: [
                v => !!v || i18n.t('validate.not_empty'),
                // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
            ],

            editorOptions: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'script': 'sub'}, { 'script': 'super' }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'color': [] }, { 'background': [] }],

                        [{ 'header': [1, 2, 3, 4, 5, 6] }],
                        [{ 'font': [] }],
                       
                        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                        ['link']
                    ],
                }
            },
        }),

        components: {
            UploadDialog: UploadDialog,
            PresentIdeaRequest: PresentIdeaRequest,
            VueEditor: VueEditor
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? i18n.t('order_unit.add') : i18n.t('order_unit.edit')
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },

            select(val) {
                console.log(val);          
            },

            selectFilterCategory() {
                this.filterData();
            }
        },

        async created () {
            if (this.isAdmin) {
                this.headers = [
                    { text: '#', align: 'left', sortable: false, value: 'index' },
                    { text: i18n.t('idea_request.name'), value: 'name' },

                    { text: i18n.t('idea_request.user'), value: 'user' },
                    { text: '', sortable: false, value: 'user.fullname', align: ' d-none'},

                    { text: i18n.t('idea_request.category'), value: 'category' },
                    { text: '', sortable: false, value: 'category.name', align: ' d-none'},

                    { text: i18n.t('idea_request.file_num'), value: 'files' },
                    // { text: i18n.t('idea_request.description'), value: 'description' },
                    { text: '', value: 'publish', sortable: false },
                    { text: '', value: 'action', sortable: false }
                ]
            } else {
                this.headers = [
                    { text: '#', align: 'left', sortable: false, value: 'index' },
                    { text: i18n.t('idea_request.name'), value: 'name' },

                    { text: i18n.t('idea_request.user'), value: 'user' },
                    { text: '', sortable: false, value: 'user.fullname', align: ' d-none'},

                    { text: i18n.t('idea_request.category'), value: 'category' },
                    { text: '', sortable: false, value: 'category.name', align: ' d-none'},

                    { text: i18n.t('idea_request.file_num'), value: 'files' },
                    // { text: i18n.t('idea_request.description'), value: 'description' },
                    { text: '', value: 'action', sortable: false }
                ]
            }
            this.getAllCategory();
            this.getData();
        },

        methods: {
            initialize () {
            },

            showDetail(item) {
                this.editedItem = item;
                this.dialogInfor = true;
            },

            closeDialogInfor() {
                this.dialogInfor = false;
                this.editedItem = {};
            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.filesUploaded = this.editedItem.files;
                this.selectedCategory = this.editedItem.category;
                this.createRequestDialog = true
            },

            async deleteItem (item) {
                const agree = confirm(i18n.t('common.confirm_delete'))
                if (agree) {
                    const response =  await this.$http.delete(process.env.VUE_APP_IDEA_REQUEST_API + item._id);
                    if(response.data && response.data.success) {
                        this.desserts.splice(item.index - 1, 1);
                        this.desserts.forEach((item, index) =>item.index = index + 1);
                    } else if(response.data && !response.data.success) {
                        alert(i18n.t(response.data.message));
                    } else {
                        alert(i18n.t('validate.request_error'));
                    }
                }
            },

            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            async save () {
                const self = this;

                if (!this.editedItem.name || this.editedItem.name.length == 0) {
                    alert(i18n.t('validate.infor_empty'));
                    return;
                }

                const requestBody = self.editedItem;

                let fileIds = [];
                this.filesUploaded.forEach(item => {
                    fileIds.push(item.id);
                });

                requestBody.files = fileIds;
                requestBody.category = self.selectedCategory;
                requestBody.uid = this.userID;

                if (this.editedIndex > -1) {
                    try {
                        const response = await this.$http.put(process.env.VUE_APP_IDEA_REQUEST_API + self.editedItem._id,  requestBody);
                        if (response.data && response.data.success) {
                            // self.editedItem = {
                            //     ...requestBody,
                            //     _id: self.editedItem._id,
                            // }
                            // console.log(response.data);
                            // Object.assign(this.desserts[this.editedIndex], this.editedItem);
                            
                            self.$fire({
                                title: i18n.t('common.update_success'),
                                text: "",
                                type: "success"
                                }).then(() => {
                                    self.getData();
                            });

                        } else if(response.data && !response.data.success) {
                            alert(i18n.t(response.data.message));
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch (e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                } else {
                    try {
                        const response = await this.$http.post(process.env.VUE_APP_IDEA_REQUEST_API, requestBody);

                        if (response.data && response.data.success) {
                            self.$fire({
                                title: i18n.t('common.success'),
                                text: "",
                                type: "success"
                                }).then(() => {
                                    self.getData();
                            });
                        } else if(response.data && !response.data.success) {
                            alert(i18n.t(response.data.message));
                        } else {
                            alert(i18n.t('validate.request_error'));
                        }
                    } catch (e) {
                        console.log(e.stack);
                        alert(i18n.t('validate.request_error'));
                    }
                }
                this.closeCreateDialog()
            },

            async getData() {
                this.loading = true;
                try {
                    let response;
                    if (this.isAdmin) {
                        response = await this.$http.get(process.env.VUE_APP_IDEA_REQUEST_API + '?status=0');
                    } else {
                        response = await this.$http.get(process.env.VUE_APP_IDEA_REQUEST_API + '?uid=' + this.userID + '&status=0');
                    }
                    this.loading = false;
                    if (response.data && response.data.success) {
                        const contextArr = response.data.data;
                        contextArr.forEach((item, index) =>item.index = index + 1);

                        this.desserts = contextArr;
                        this.fullRequests = contextArr;
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            },

            filterData() {
                if (!this.fullRequests || this.fullRequests.length == 0) {
                    return;
                }

                if (this.selectFilterCategory._id === "-1") {
                    this.desserts = [].concat(this.fullRequests);
                    console.log(this.desserts);
                    return;
                }

                let dataArray = [];

                this.fullRequests.forEach(item => {
                    if (item && item.category._id === this.selectFilterCategory._id) {
                        dataArray.push(item);
                    }
                })
                
                this.desserts = [].concat(dataArray);
            },

            showCreateRequestDialog() {
                this.createRequestDialog = true;
            },

            closeCreateDialog() {
                this.createRequestDialog = false;
                this.editedItem = {};
                this.editedIndex = -1;
            },

            uploadFile(value) {
                this.filesUploaded = this.filesUploaded.concat(value);
            },

            deleteImage(file) {
                if (Array.isArray(this.filesUploaded) && this.filesUploaded.length > 0) {
                    const agree = confirm(i18n.t('common.confirm_delete'));
                    if (agree) {
                        this.filesUploaded.splice(this.filesUploaded.indexOf(file), 1);
                    }
                }
            },

            async approve(item) {
                const agree = confirm(i18n.t('common.confirm_approve_idea'));
                if (!agree) {
                    return;
                }
                const self = this;
                const requestBody = {
                    status: 1
                }

                try {
                    const response = await this.$http.put(process.env.VUE_APP_IDEA_REQUEST_API + item._id + '/status', requestBody);

                    if (response.data && response.data.success) {
                        self.$fire({
                            title: i18n.t('common.update_success'),
                            text: "",
                            type: "success"
                            }).then(() => {
                                self.getData();
                        });
                    } else if(response.data && !response.data.success) {
                        alert(i18n.t(response.data.message));
                    } else {
                        alert(i18n.t('validate.request_error'));
                    }
                } catch (e) {
                    console.log(e.stack);
                    alert(i18n.t('validate.request_error'));
                }
            },

            async getAllCategory() {
                try {
                    const response = await this.$http.get(process.env.VUE_APP_IDEA_CATEGORY_API);
                    
                    if (response.data && response.data.success) {
                        const optionAll = {
                            name : "Tất cả",
                            _id : "-1"
                        }

                        this.filterCategories = [optionAll].concat(response.data.data);
                        this.categories = response.data.data;
                        if (this.categories.length > 0) {
                            this.selectedCategory = this.categories[0];
                        }
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            }
        },
    }
</script>